import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { BaseComponent } from "@content/base/base.component";
import { ContactComponent } from "@content/contact/contact.component";
import { DataGenerateComponent } from "@content/data-generate/data-generate.component";
import { DevelopmentsComponent } from "@content/developments/developments.component";
import { ErrorComponent } from "@content/error/error.component";
import { InfoDefinitionComponent } from "@content/info-definition/info-definition.component";
import { IconsComponent } from "@content/icons/icons.component";
import { LandingPageComponent } from "@content/landing-page/landing-page.component";
import { ProjectsComponent } from "@content/projects/projects.component";
import { PasswordGuard } from "@guards/password.guard";
import { BaseResolver } from "@resolvers/base.resolver";
import { ContactResolver } from "@resolvers/contact.resolver";
import { DevelopmentsResolver } from "@resolvers/developments.resolver";
import { ErrorResolver } from "@resolvers/error.resolver";
import { ProjectsResolver } from "@resolvers/projects.resolver";
import RouteParams from "@shared/route-params";
import { environment } from "src/environments/environment";
import { DataAutomationComponent } from "@content/data-automation/data-automation.component";

const routes: Routes = [
  {
    path: "",
    component: BaseComponent,
    canActivate: [PasswordGuard],
    resolve: {
      data: BaseResolver,
    },
    children: [
      {
        path: "",
        component: LandingPageComponent,
      },
      {
        path: `developments/:${RouteParams.ItemId}`,
        component: DevelopmentsComponent,
        runGuardsAndResolvers: "always",
        resolve: {
          developmentData: DevelopmentsResolver,
        },
      },
      {
        path: `projects/:${RouteParams.developmentId}/:${RouteParams.ItemId}`,
        component: ProjectsComponent,
        runGuardsAndResolvers: "always",
        resolve: {
          projectData: ProjectsResolver,
        },
      },
      {
        path: "infodefinition",
        component: InfoDefinitionComponent,
      },
      {
        path: `contact/:${RouteParams.ItemId}`,
        component: ContactComponent,
        resolve: { contactData: ContactResolver },
      },
      {
        path: `contact`,
        component: ContactComponent,
        resolve: { contactData: ContactResolver },
      },
      {
        path: "generate",
        component: DataGenerateComponent,
      },
      {
        path: "generateData",
        component: DataAutomationComponent,
      },
      {
        path: "icons",
        component: IconsComponent,
      },
      {
        path: `error/:${RouteParams.ErrorCode}`,
        component: ErrorComponent,
        resolve: { errorData: ErrorResolver },
      },
      {
        path: "**",
        redirectTo: "/error/404",
        pathMatch: "full",
      },
    ],
  },
  {
    path: "**",
    redirectTo: environment.hostURL.includes("localhost") ? "" : environment.hostURL,
    pathMatch: "full",
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
